import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import _ from 'lodash';

import { CourseProgress } from '@/openapi/user';
import { CourseId } from '@/openapi/enum';

import SectionMixin from '@/user/mixins/SectionMixin';
import UserMixin from '@/user/mixins/UserMixin';

import UserApiUtility from '@/classes/common/UserApiUtility';




type State = {
  progresses: CourseProgress[];
};

const state = Vue.observable<State>({
  progresses: []
});

export default mixins(SectionMixin, UserMixin).extend({

  name: 'CourseProgressMixin',

  computed: {
    progresses(): CourseProgress[] {
      return state.progresses;
    },
  },

  methods: {
    async loadProgressesState(courseId: CourseId): Promise<void> {
      // 単元情報読み込み
      await this.loadSections(courseId);

      // 進捗情報設定
      if (this.isGuest) {
        if (state.progresses.length === 0) state.progresses = [];
      } else if (this.isSectionComplete) {
        state.progresses = this.$_createCourseProgresses(this.lastSectionNo, this.lastSectionUnitNo);
      } else if (this.isOneUnitLeft) {
        state.progresses = this.$_createCourseProgresses(this.lastSectionNo, this.lastSectionUnitNo - 1);
      } else {
        const response = await UserApiUtility.getUserProgressApi().showUserProgress(courseId);
        state.progresses = response.data;
      }
    },
    setProgresses(progresses: CourseProgress[]): void {
      state.progresses = progresses;
    },
    clearProgresses(): void {
      state.progresses = [];
    },
    $_createCourseProgresses(sectionNo: number, unitNo: number): CourseProgress[] {
      let progresses: CourseProgress[] = [];
      for (let i = this.firstSectionNo; i < sectionNo + 1; i++) {
        const lastUnitNo = i < sectionNo ? this.sections[i].unitCount : unitNo;
        const unitNos    = unitNo > 0 ? _.range(lastUnitNo) : [];
        progresses.push({
          sectionNo: i,
          unitNos
        });
      }
      return progresses;
    }
  }

});
